import { FeatureService } from '@spotahome/ui-library';

const NA_BILL_VALUE = 'na';

export const utilitiesMap = {
  electricity: {
    name: 'electricity',
    title: 'search.filter.electricity',
    icon: 'electricity'
  },
  water: {
    name: 'water',
    title: 'search.filter.water',
    icon: 'water'
  },
  gas: {
    name: 'gas',
    title: 'search.filter.gas',
    icon: 'gas'
  },
  wifi: {
    name: 'wifi',
    title: 'search.filter.wifi',
    icon: 'wifi'
  }
};
const utilitiesAvailable = Object.keys(utilitiesMap);

export const adaptFeatures = features =>
  FeatureService.getFeaturesAsList(features);

export const adaptBills = bills =>
  FeatureService.getFeaturesAsList(bills)
    .filter(bill => bill.value !== NA_BILL_VALUE)
    .map(bill =>
      bill.value === true
        ? { ...bill, isIncluded: true }
        : { ...bill, isIncluded: false }
    );

export const getBillsFromFeatures = propertyFeatures => {
  if (!propertyFeatures) {
    return [];
  }
  const propFeatKeys = Object.keys(propertyFeatures);
  const billsFromFeatures = propFeatKeys.reduce((memo, current) => {
    const { category, value, additionalInfo } = propertyFeatures[current];
    return category === 'bills' && utilitiesAvailable.includes(current)
      ? [
          ...memo,
          {
            key: current,
            value,
            additionalInfo
          }
        ]
      : memo;
  }, []);

  return billsFromFeatures;
};

export default {
  adaptFeatures,
  adaptBills,
  getBillsFromFeatures
};
